import { SVGProps, FC } from "react";
import { LogoName } from "./LogoName";

/**
 * A context return function.
 */
interface ContextFn {
  /**
   * Gets the imported data for the specified path.
   * @param path The path to get the data for.
   * @returns The data, if any.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (path: string): any;
}

/**
 * Provides a declaration for the webpack `require.context` method.
 */
interface WebpackContextRequire {
  /**
   * Creates a new webpack context.
   * @param path The path to create the context under.
   * @param deep Whether to search child directories.
   * @param pattern The pattern for files to locate.
   */

  context(path: string, deep?: boolean, pattern?: RegExp): ContextFn;
}

/**
 * The default logo provider.
 * @returns Always undefined.
 */
function DefaultLogoProvider(): unknown {
  return undefined;
}

let availableLogos: ContextFn = DefaultLogoProvider;

try {
  availableLogos = (require as unknown as WebpackContextRequire).context("!@svgr/webpack!./logos", true, /\.svgi$/);
} catch {
  // do nothing.
}

/**
 * Gets the logo for the specified name and size.
 * @param name The name of the logo to retrieve.
 * @returns The logo component or null if none found.
 */
export function getLogoComponent(name: LogoName): FC<SVGProps<SVGSVGElement> & { title?: string }> | null {

  while (true) {
    let logo: FC<SVGProps<SVGSVGElement> & { title?: string }> | null;

    try {
      const module = availableLogos(`./${name}.svgi`);
      logo = module?.default;
    } catch {
      logo = null;
    }

    if (logo) {
      return logo;
    } else {
      return null;
    }
  }
}
